export default "__VITE_ASSET__CNZkijEJ__"